import {
  CallAuditLog,
  CallAuditLogModel,
  CallAuditNote,
  CallAuditNoteModel
} from "src/models/callAuditLogs";
import { erebus } from "boot/axios";

export default class CallAuditLogService {
  /**
   * Retrieves call audit logs for a specific patient record
   * @param patientRecordID - The ID of the patient record
   * @returns Promise resolving to a call audit log
   */
  async getCallAuditLogsByPatientRecord(patientRecordID: number): Promise<CallAuditLog | null> {
    const res = await erebus.get("/ivr/logs/patient-record-logs", {
      params: { patientRecordID }
    });

    if (res.data === null) {
      return null;
    }

    if (!CallAuditLogModel.validate(res.data)) {
      throw new Error("Invalid CallAuditLog data received from server");
    }

    return new CallAuditLogModel(res.data);
  }

  /**
   * Retrieves call audit notes for a specific activation
   * @param activationID - The ID of the activation
   * @returns Promise resolving to array of call audit notes
   */
  async getCallAuditNotesByActivation(activationID: number): Promise<CallAuditNote[]> {
    const res = await erebus.get("/ivr/logs/call-log-notes", {
      params: { activationID }
    });

    if (res.data === null || res.data.length === 0) {
      return [];
    }

    // Convert the response to CallAuditNote models
    return res.data.map((noteData: any) => {
      if (!CallAuditNoteModel.validate(noteData)) {
        throw new Error("Invalid CallAuditNote data received from server");
      }
      return new CallAuditNoteModel(noteData);
    });
  }
}